/** @format */

const template = `
{{'STUDENT_APPLICATIONS.code' | translate}}: <span class="code">{{code}}</span>
`;
export default template;
